import {
  type ExternalActionRequest,
  ExternalActionRequestType
} from 'types/api/scenarios/scenario'

export enum NodeSectionType {
  ExternalActions = 'ExternalActions',
  ExternalRollbacks = 'ExternalRollbacks',
  Observers = 'Observers',
  Nodes = 'Nodes'
}

export const NODE_SECTION_LABELS = {
  [NodeSectionType.ExternalActions]: 'External Steps',
  [NodeSectionType.ExternalRollbacks]: 'External Rollback Steps',
  [NodeSectionType.Observers]: 'Health Checks',
  [NodeSectionType.Nodes]: 'Gremlin Steps'
}

export function getExternalActionText(
  externalActionRequest: ExternalActionRequest
) {
  switch (externalActionRequest.type) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return 'Disable'
    case ExternalActionRequestType.RemoveAWSSecurityGroups:
      return 'Remove'
    default:
      return 'Re-enable'
  }
}

export function getExternalActionTargetPrefix(
  externalActionRequest: ExternalActionRequest,
  includeTransition = true
) {
  switch (externalActionRequest.type) {
    case ExternalActionRequestType.DisableAWSAutoScalingGroups:
      return `ASG autoscaling${includeTransition ? ' on' : ''}`
    default:
      return `Security Group${includeTransition ? ' from' : ''}`
  }
}
